import { useLocationContext } from '../providers/location.provider';
import { getLoanApplicationPolicies } from '../utils';

/**
 * The loan-application policy document set (Terms, Privacy, ACH) for the user's
 * current US/PR location. PR users get the FCMC PR-specific PDFs; everyone else
 * gets the default set. Keys are stable across locations, so callers just read
 * `policies.FCMC_TERMS` etc. without branching.
 */
export const usePolicies = () => {
  const { location } = useLocationContext();
  return getLoanApplicationPolicies(location);
};
